import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function PginPune(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
    const faqs = [
        {
          question: "What type of rooms are available at Om Sai PG?",
          answer: "We offer both single and shared rooms with modern furniture, including beds, wardrobes, and study tables. All rooms are well-ventilated and spacious."
        },
        {
          question: "Is there any security at Om Sai PG?",
          answer: "Yes, we have 24/7 security staff and CCTV surveillance throughout the premises to ensure the safety and well-being of all residents."
        },
        {
          question: "What is the cost of staying at Om Sai PG?",
          answer: "The rent varies depending on the room type (single or shared) and the duration of stay. Please contact us directly for detailed pricing."
        },
        {
          question: "What facilities are included in the rent?",
          answer: "The rent includes fully furnished rooms, Wi-Fi, electricity, water, housekeeping services, and meals (breakfast, lunch, and dinner)."
        },
        {
          question: "Is food provided at Om Sai PG?",
          answer: "Yes, we provide freshly prepared, nutritious meals daily, including breakfast, lunch, and dinner. We ensure the food is hygienic and meets different dietary preferences."
        },
        {
          question: "Can I book a room for a short-term stay?",
          answer: "Yes, we offer flexible stay options, including both short-term and long-term stays. You can choose the duration based on your needs."
        },
        {
          question: "How far is Om Sai PG from Pune’s major landmarks?",
          answer: "Om Sai PG is centrally located, with easy access to key areas like Koregaon Park, Viman Nagar, Kalyani Nagar, and other major educational and commercial hubs of Pune."
        },
        {
          question: "Is there parking available?",
          answer: "Yes, we provide parking facilities for residents with vehicles, ensuring your car or bike is safely parked."
        },
        {
          question: "Do you provide laundry services?",
          answer: "Yes, we offer laundry services at an additional charge. We ensure your clothes are cleaned and returned on time."
        },
        {
          question: "How can I make a booking at Om Sai PG?",
          answer: "You can book a room by contacting us directly via phone or email. We’ll guide you through the booking process, room selection, and any other inquiries you may have."
        }
      ];
      
      const testimonials = [
        {
          quote: "I’ve been staying at Om Sai PG for the past six months, and it has been a wonderful experience. The rooms are spacious, well-maintained, and have all the amenities one could ask for. The food served is homely and delicious, and I never had to worry about cleanliness. The staff is friendly and always ready to help with any issues. It’s located in a prime area of Pune, making commuting easy. I highly recommend Om Sai PG to anyone looking for a safe and comfortable place to stay.",
          author: "- Mr. Amit Sharma, IT Professional"
        },
        {
          quote: "I moved to Pune for my studies, and Om Sai PG has been the perfect place for me. The PG offers a peaceful environment, which is ideal for my studies. The rooms are cozy and equipped with everything I need, and the Wi-Fi speed is great. The management team ensures the place is clean and well-maintained. The food options are varied and taste great. I’ve felt at home here since day one. It’s a great place for students or working professionals, and I’m glad I chose Om Sai PG.",
          author: "- Mrs. Neha Patel, Student"
        }
      ];
      

      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
    
    
    return(
        <>

<Helmet>
  {/* JSON-LD Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/PG-In-Pune",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/img/keyword-image/pg-in-pune.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "keywords": [
        "PG in Pune",
        "Single Room PG in Pune",
        "PG in Kharadi",
        "Best PG Near Eon IT Park"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Om Sai PG | PG in Pune | Single Room PG in Kharadi | Best PG Near Eon IT Park
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers the best PG accommodations in Kharadi, Pune, with food included. Ideal for students, professionals, and residents."
  />
  <meta
    name="keywords"
    content="PG in Pune, Single Room PG in Pune, PG in Kharadi, Best PG Near Eon IT Park"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/pg-in-pune.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/PG-In-Pune" />
  <meta property="og:type" content="website" />
</Helmet>

     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>PG In Pune</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>About</h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>PG In Pune</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/pg-in-pune.jpg" className="img-fluid" alt="Pg in pune" />
              </div>
              <h1>PG in Pune: Om Sai PG – Affordable and Comfortable Accommodation Near EON IT Park, Kharadi</h1>

<p>Om Sai PG is the perfect solution for students and working professionals looking for a hassle-free and home-like living experience in the heart of Kharadi, near the renowned EON IT Park. With top-notch facilities, spacious rooms, and an ideal location, Om Sai PG ensures that your stay in Pune is both comfortable and memorable.</p>

<h2>Key Facilities Provided at Om Sai PG in Pune:</h2>

<p>At Om Sai PG, we provide a wide range of facilities to ensure that your stay is as comfortable and convenient as possible. Here’s a look at some of the top amenities that make our PG accommodation stand out:</p>

<h3>1. Fully Furnished Rooms</h3>
<p>Each room at Om Sai PG is spacious, well-furnished, and equipped with essential furniture such as comfortable beds, wardrobes, and study tables to cater to your needs, whether for work or study. We provide TV per room for your entertainment and relaxation.</p>

<h3>2. Washing Machine</h3>
<p>Say goodbye to the hassle of finding a laundromat. At Om Sai PG, we offer a washing machine for the convenience of all our guests, so you can easily manage your laundry needs.</p>

<h3>3. High-Speed Wi-Fi</h3>
<p>Stay connected with free high-speed Wi-Fi available throughout the property. Whether you need it for work, study, or leisure, you can rely on our fast and uninterrupted internet connection.</p>

<h3>4. 24/7 Water and Hot Water Supply</h3>
<p>24/7 water supply ensures that you have access to water at all times, while our 24-hour hot water availability means you can enjoy a warm shower whenever you need it.</p>

<h3>5. Geyser</h3>
<p>All rooms are equipped with geysers to ensure that you can enjoy hot water during the chilly mornings and evenings.</p>

<h3>6. 2-Wheeler Parking Available</h3>
<p>For those who own a two-wheeler, Om Sai PG provides secure 2-wheeler parking, so you don’t have to worry about your vehicle’s safety.</p>

<h3>7. Fridge and Gas Facility</h3>
<p>Our PG comes with a fridge to store your food and drinks, ensuring that you always have access to cold beverages or leftovers. Additionally, gas is available for cooking.</p>

<h3>8. Free Housekeeping</h3>
<p>To maintain cleanliness and hygiene, free housekeeping services are provided. Our team takes care of cleaning the rooms and common areas regularly.</p>

<h3>9. Free Electricity Bill</h3>
<p>We understand the importance of convenience, which is why electricity bills are included for free. You can enjoy the comfort of your room without worrying about monthly power costs.</p>

<h3>10. Purified Drinking Water</h3>
<p>The health and well-being of our guests are paramount, which is why we provide purified drinking water to ensure safe and clean hydration.</p>

<h3>11. CCTV Surveillance</h3>
<p>For your safety and peace of mind, Om Sai PG is equipped with CCTV cameras that monitor the premises 24/7, ensuring a secure living environment.</p>



<h2>Affordable Accommodation Pricing at Om Sai PG</h2>
<p>We offer budget-friendly PG accommodation without compromising on comfort. Our room pricing includes breakfast and dinner, ensuring that you always have wholesome meals to start and end your day. Here are our affordable pricing options:</p>
<ul>
  <li>Sharing Room: ₹8,500/month (Including Breakfast and Dinner)</li>
  <li>Sharing Room: ₹7,000/month (Including Breakfast and Dinner)</li>
  <li>Sharing Room: ₹6,000/month (Including Breakfast and Dinner)</li>
</ul>
<p>Our pricing is designed to provide the best value for money while ensuring that you have access to all the essential amenities.</p>

<h2>Location – Kharadi, Near EON IT Park</h2>
<p>Om Sai PG is strategically located in Kharadi, which is well-connected to key areas of Pune such as Magarpatta, Kalyani Nagar, and Hadapsar. The proximity to EON IT Park makes it an excellent choice for IT professionals working in the area. With great accessibility to public transport, Om Sai PG ensures easy commuting within Pune.</p>

<h2>Om Sai PG for Female with Food in Pune</h2>
<p>Looking for a safe, comfortable, and affordable PG for females in Pune? Om Sai PG in Kharadi offers fully furnished rooms with high-quality food and a homely environment. Whether you're a working professional or a student, our PG is equipped with modern amenities like Wi-Fi, 24/7 water supply, housekeeping, and security. Enjoy nutritious meals, personalized care, and a peaceful atmosphere, perfect for women seeking both comfort and convenience in Pune. Book your stay at Om Sai PG today!</p>

<h2>Paying Guest in Pune for Male with Food</h2>
<p>Om Sai PG in Kharadi offers the best paying guest accommodations for males in Pune, complete with meals, making it the ideal choice for professionals and students. With spacious rooms, quality food, and round-the-clock security, our PG caters to your daily needs while providing a homely atmosphere. Located in a prime area of Pune, our facility is designed for comfort and convenience. Stay with us and experience a hassle-free lifestyle with nutritious meals and essential amenities!</p>

<h2>PG in Pune for Students</h2>
<p>Om Sai PG in Kharadi is the perfect choice for students looking for a safe and affordable PG accommodation in Pune. We offer fully furnished rooms, delicious meals, high-speed internet, and a supportive environment, all designed to help you focus on your studies. With proximity to major educational institutes, transportation, and 24/7 security, our PG provides everything you need for a comfortable stay. Book your stay at Om Sai PG today and enjoy the convenience of home-like amenities!</p>

<h2>PG in Pune for Couples</h2>
<p>Om Sai PG in Kharadi offers cozy and spacious paying guest accommodations for couples in Pune. We understand the importance of privacy and comfort, which is why our rooms are designed with modern amenities and personalized services. Enjoy home-cooked meals, round-the-clock security, and the warmth of a caring environment. Whether you're a newly married couple or long-time partners, our PG provides a peaceful retreat with everything you need for a stress-free living experience. Contact us today to learn more!</p>

<h2>PG in Pune for Girls</h2>
<p>Om Sai PG in Kharadi offers top-tier paying guest accommodation for girls in Pune, ensuring safety, comfort, and convenience. Our PG is equipped with spacious rooms, nutritious food, high-speed Wi-Fi, and 24/7 security, creating the perfect environment for women to live peacefully. Located near major hubs of Pune, our PG provides easy access to work, education, and transportation. Enjoy a homely experience with extra care and attention to your needs. Book your stay with Om Sai PG today for a hassle-free and comfortable lifestyle.</p>

<h2>PG in Pune for Boys</h2>
<p>Om Sai PG in Kharadi is the ideal choice for boys looking for paying guest accommodations in Pune. We offer well-furnished rooms, nutritious meals, high-speed internet, and top-notch security for your safety and comfort. Located in the heart of Pune, our PG is close to offices, educational institutions, and transportation. Whether you're a student or a professional, Om Sai PG provides the ideal balance of affordability and comfort. Contact us to book your stay today!</p>

<h2>Om Sai PG Kharadi</h2>
<p>Om Sai PG in Kharadi offers the best paying guest accommodations in Pune, providing a comfortable and secure living experience for all types of residents, including students, professionals, couples, and families. With fully furnished rooms, home-cooked meals, high-speed internet, and 24/7 security, we ensure you have everything you need for a pleasant stay. Located in a prime location with easy access to all major areas of Pune, Om Sai PG is the perfect choice for anyone looking for affordable, comfortable, and convenient accommodation. Book your room today!</p>


            <h2>Om Sai PG for "PG In Pune" Contact Number:- </h2>
            <p>Contact Om Sai PG at +91 9763888448 / +91 9922248255. Our PG is strategically located in the heart of Kharadi, one of Pune's most vibrant and accessible neighborhoods, making it an ideal choice for students and professionals alike.</p>

            
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - PG in Pune for Female with Food</p>
<p> - PG in Pune for Male with Food</p>
<p> - PG in Pune for Students</p>
                    </td>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - PG in Pune for Couples</p>
<p> - PG in Pune for Girls</p>
<p> - PG in Pune for Boys</p>
<p> - OM Sai PG Kharadi</p>

                    </td>
                  </tr>
                </tbody>
              </table>

              <h1>Why Choose Om Sai PG for PG in Pune?</h1>

<h2>1. Prime Location</h2>
<p>Om Sai PG is situated in a prime location in Pune, ensuring easy access to all major educational institutions, workplaces, and transportation hubs. Whether you're a student or a working professional, you’ll find it convenient to reach your destination.</p>

<h2>2. Comfortable and Modern Rooms</h2>
<p>Our PG accommodation features well-furnished, spacious rooms with all the necessary amenities. Whether you choose a single or shared room, we guarantee a comfortable and peaceful living environment.</p>

<h2>3. 24/7 Security and CCTV Surveillance</h2>
<p>Your safety is our priority. We have round-the-clock security personnel and CCTV cameras in place to ensure a safe living environment for all our residents.</p>

<h2>4. Homely and Hygienic Meals</h2>
<p>We provide freshly cooked, nutritious meals daily. The food is prepared in a clean, hygienic environment to meet the taste and dietary preferences of our residents.</p>

<h2>5. Affordable Pricing</h2>
<p>We offer competitive and affordable pricing for our rooms, ensuring that you can enjoy a quality living experience without burning a hole in your pocket.</p>

<h2>6. 24/7 Wi-Fi and Other Amenities</h2>
<p>Stay connected with fast and reliable Wi-Fi throughout the PG. We also provide regular housekeeping, water, electricity, and other essential facilities to make your stay hassle-free.</p>

<h2>7. Proximity to Key Areas</h2>
<p>Om Sai PG is located near key commercial and educational hubs in Pune, ensuring that you don’t waste time commuting. Major areas like Koregaon Park, Viman Nagar, Kalyani Nagar, and more are within easy reach.</p>

<h2>8. Friendly Environment</h2>
<p>We foster a friendly and welcoming environment for all our residents. Our team is always ready to assist you with any needs and queries, making you feel at home.</p>

<h2>9. Strict Adherence to Cleanliness</h2>
<p>We maintain high standards of cleanliness and hygiene throughout the property. Regular cleaning services ensure that your rooms and common areas stay tidy and pleasant.</p>

<h2>10. Flexible Stay Options</h2>
<p>Whether you need short-term accommodation or a long-term stay, we offer flexible rental agreements to suit your needs. Our booking process is simple and transparent.</p>

              
              <div className="">
                  <h2>
                  FAQs for Om Sai PG in Pune ?
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonial for “Om Sai PG” for Pune in PG: - {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
